import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Call {
  call_id: string;
  agent_id: string;
  phone_number_id?: string;
  caller_number?: string;
  status: 'in-progress' | 'completed' | 'failed' | 'queued';
  duration?: number;
  transcript?: string;
  recording_url?: string;
  started_at: string;
  ended_at?: string;
}

export interface CallStats {
  totalCalls: number;
  totalMinutes: number;
  avgDuration: number;
  completionRate: number;
}

interface CallsState {
  activeCalls: Call[];
  callHistory: Call[];
  isLoading: boolean;
  stats: CallStats | null;
}

const initialState: CallsState = {
  activeCalls: [],
  callHistory: [],
  isLoading: false,
  stats: null,
};

export const callsSlice = createSlice({
  name: 'calls',
  initialState,
  reducers: {
    setActiveCalls(state, action: PayloadAction<Call[]>) {
      state.activeCalls = action.payload;
    },
    setCallHistory(state, action: PayloadAction<Call[]>) {
      state.callHistory = action.payload;
    },
    setStats(state, action: PayloadAction<CallStats | null>) {
      state.stats = action.payload;
    },
    addCall(state, action: PayloadAction<Call>) {
      state.activeCalls.unshift(action.payload);
    },
    updateCall(state, action: PayloadAction<Call>) {
      const idx = state.activeCalls.findIndex((c) => c.call_id === action.payload.call_id);
      if (idx !== -1) state.activeCalls[idx] = action.payload;
      const hIdx = state.callHistory.findIndex((c) => c.call_id === action.payload.call_id);
      if (hIdx !== -1) state.callHistory[hIdx] = action.payload;
    },
    setCallsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setActiveCalls,
  setCallHistory,
  setStats,
  addCall,
  updateCall,
  setCallsLoading,
} = callsSlice.actions;
